import { useEffect, useState } from "react";
import { api, EvidenceBadge } from "@/lib/api";
import { toast } from "sonner";
import { Plus } from "lucide-react";

export default function Trends() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ name: "", source: "manual", suggested_angle: "", hop_relevance: 60, relevance_score: 60 });

  const load = () => api.get("/trends").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!form.name) return;
    await api.post("/trends", form);
    setForm({ name: "", source: "manual", suggested_angle: "", hop_relevance: 60, relevance_score: 60 });
    toast.success("Trend added");
    load();
  };

  const setStatus = async (id, status) => { await api.patch(`/trends/${id}`, { status }); load(); };

  return (
    <div className="p-8 max-w-[1400px]">
      <div className="mb-8">
        <div className="text-xs uppercase tracking-widest text-neutral-500 font-semibold mb-1">Trend Inbox</div>
        <h1 className="text-5xl font-black tracking-tight leading-none" style={{ fontFamily: "'Cabinet Grotesk', system-ui, sans-serif" }}>Trends</h1>
      </div>

      <div className="bg-white border border-neutral-200 rounded-lg p-4 mb-6 flex flex-wrap gap-2 items-end">
        <input data-testid="trend-name" placeholder="Trend name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="border border-neutral-300 rounded px-3 py-2 text-sm flex-1 min-w-[200px]" />
        <input data-testid="trend-angle" placeholder="Suggested angle for HOP!" value={form.suggested_angle} onChange={(e) => setForm({ ...form, suggested_angle: e.target.value })} className="border border-neutral-300 rounded px-3 py-2 text-sm flex-1 min-w-[240px]" />
        <button data-testid="add-trend-btn" onClick={add} className="px-4 py-2 rounded font-semibold text-sm text-neutral-900 flex items-center gap-1" style={{ background: "#D4FF00" }}><Plus className="w-3 h-3" />Add</button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((t) => (
          <div key={t.id} data-testid={`trend-${t.id}`} className="bg-white border border-neutral-200 rounded-lg p-5">
            <div className="flex items-start justify-between mb-2">
              <div className="text-xs uppercase tracking-widest text-neutral-500 font-semibold">{t.status}</div>
              <EvidenceBadge confidence={t.relevance_score >= 75 ? "high" : t.relevance_score >= 50 ? "medium" : "experiment"} />
            </div>
            <div className="font-bold text-lg leading-snug" style={{ fontFamily: "'Cabinet Grotesk', system-ui, sans-serif" }}>{t.name}</div>
            <div className="text-sm text-neutral-600 mt-1">{t.suggested_angle}</div>
            <div className="text-xs text-neutral-500 mt-2">Momentum: {t.momentum} · Score: {t.relevance_score}/100</div>
            <div className="flex gap-2 mt-3">
              <button data-testid={`use-${t.id}`} onClick={() => setStatus(t.id, "use_now")} className="text-xs font-semibold px-2 py-1 rounded text-neutral-900" style={{ background: "#D4FF00" }}>Use now</button>
              <button data-testid={`reject-${t.id}`} onClick={() => setStatus(t.id, "rejected")} className="text-xs font-semibold px-2 py-1 rounded border border-neutral-300 hover:bg-neutral-50">Reject</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
